import { useBrandingContext } from "@/providers/BrandingProvider";

export function useBranding() {
  const { branding, isLoading, error } = useBrandingContext();
  return { branding, isLoading, error };
}
